import { rootMargin } from '@helpers/animate';
import { BrandColours } from '@helpers/brand';
import { InterfaceIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './DownloadCard.styles';
const DownloadCard = (props) => {
    const imageSrc = props.image ? getSrcs(props.image, 1392, 344, 15, 695 / 392) : null;
    const [ref, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    return (React.createElement(S.Container, { ref: ref, "data-variant": props.theme ?? BrandColours.PurpleDark, "data-animate": inView },
        React.createElement(S.Grid, null,
            React.createElement(S.ContentArea, null,
                React.createElement(S.Heading, null, props.title),
                props.description && React.createElement(S.Content, null, props.description),
                (props.cta || props.previewCta) && (React.createElement(S.CtaArea, null,
                    props.cta && (React.createElement(LinkButton, { href: props.cta.url, buttonType: "primary", icon: InterfaceIcon.Download, iconOnly: false, download: true }, props.cta.text)),
                    props.previewCta && (React.createElement(LinkButton, { href: props.previewCta.url, buttonType: "secondary", icon: InterfaceIcon.External, iconOnly: false, target: props.previewCta.target }, props.previewCta.text))))),
            imageSrc && (React.createElement(S.ImageArea, null,
                React.createElement(S.ImageContainer, null,
                    React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText, loading: "lazy", sizes: props.sizes })),
                React.createElement(S.ImageReflection, null,
                    React.createElement(S.Image, { src: imageSrc.src, srcSet: imageSrc.srcSet, alt: props.image.altText, loading: "lazy", sizes: props.sizes })))))));
};
export default DownloadCard;
